import renderPage from './client-common';
import getRoutes from '../src-sites/domik/routes';

window.__PROJECT__ = 'domik';

renderPage(getRoutes(), { cssVars: 'domik' });
